var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"data":_vm.data,"onManager":_vm.onManager,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"nameRules":[{ required: true, message: this.$t('common.text00042') }],"hiddenKeys":['tenant'],"status-module":"cloudaccount"}})
}
var staticRenderFns = []

export { render, staticRenderFns }